import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import _ from 'lodash';
import { nativeScrollTo } from 'ziphy-web-shared/basic/helpers';
import { Button } from 'ziphy-web-shared/basic/lib/buttons';
import { FloatingBar } from 'ziphy-web-shared/basic/lib/simple';
import { $layouts } from 'ziphy-web-shared/basic/utils/layouts';
import styles from './SignErrors.module.scss';
const SignErrors = ({ errors, showFloatingBar, onClose, className }) => {
    const { t } = useTranslation();
    const [currentErrorIndex, setCurrentErrorIndex] = useState(0);
    const [preparedErrors, setPreparedErrors] = useState([]);
    useEffect(() => {
        const result = [];
        errors.forEach((error) => {
            error.refs.forEach((x) => {
                const id = `ref_${x.split('|').at(-1)}`;
                const element = document.getElementById(id);
                if (element)
                    result.push([id, element.getBoundingClientRect().top]);
            });
        });
        const sorted = _.sortBy(result, (x) => x[1]);
        setPreparedErrors(sorted);
    }, [errors]);
    useEffect(() => {
        if (preparedErrors.length === 0) {
            setCurrentErrorIndex(0);
        }
        else if (currentErrorIndex >= preparedErrors.length) {
            setCurrentErrorIndex(0);
        }
    }, [preparedErrors, currentErrorIndex]);
    const handleNextError = () => {
        if (preparedErrors.length === 0)
            return;
        const nextIndex = (currentErrorIndex + 1) % preparedErrors.length;
        setCurrentErrorIndex(nextIndex);
        const [nextId] = preparedErrors[nextIndex];
        nativeScrollTo(nextId, { behavior: 'smooth', block: 'center' });
        // const element = document.getElementById(nextId)
        // if (element) {
        //   element.classList.add('animation-shake')
        //   setTimeout(() => element.classList.remove('animation-shake'), 700)
        // }
    };
    return (_jsxs("div", Object.assign({ className: classNames(styles.wrapper, className) }, { children: [errors.map((error) => (_jsx("div", Object.assign({ className: styles.error }, { children: error.text }), error.code))), showFloatingBar && preparedErrors.length > 0 && (_jsx(FloatingBar, Object.assign({ label: t('label.resolve_errors_before_signing'), onClose: onClose, bottomOffset: $layouts.marginBottom }, { children: _jsx(Button, Object.assign({ mode: ['danger', 'sm'], onClick: handleNextError }, { children: t('label.errors', { count: preparedErrors.length }) })) })))] })));
};
export default observer(SignErrors);
